<template>
  <!-- dashboard-area start -->
  <div class="dashboard-area pt-30">
    <div class="container cardspadding" >
      <div class="col-md-12 cardspadding" >
        <div class="row counter-box">
          <!-- <div class="col-lg-3 col-md-6">
            <monitoramento-comp />
          </div>-->
          <div class="col-12 titulo cardspadding" >
            <div class="bg-white">
              <h5 class="titulo">Pesquise a NCM que deseja monitorar</h5>

              <b-form-radio-group
                class="botaoradio"
                
                id="radio-group-1"
                v-model="pesquisa"
                :options="opcoes"
                name="radio-options"
              ></b-form-radio-group>
            </div>
          </div>

          <div class="col-lg-12 col-md-12 cardspadding">
            <monitoramento-pesquisa
              :selecionado="pesquisa"
              @alterado="atualizaValor"
              v-if="pesquisa == 1"
            />
          </div>

          <div class="col-lg-12 col-md-12" style="padding: 0">
            <monitoramento-pesquisadesc
              :selecionado="pesquisa"
              @alterado="atualizaValor"
              v-if="pesquisa == 2"
            />
          </div>
          <div class="col-12" style="padding: 0">
            <monitoramento-alteracoes />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- dashboard-area end -->
</template>

<script>
//import monitoramento_comp from "../components/monitoramento/monitoramento_comp";
import monitoramento_pesquisa from "../components/monitoramento/monitoramento_pesquisa";
import monitoramento_pesquisaDesc from "../components/monitoramento/monitoramento_pesquisaDesc";
import monitoramento_alteracoes from "../components/monitoramento/monitoramento_alteracoes";
import serviceHome from "../services/ServiceHome";
import serviceCookie from "../services/ServiceCookie";
import { routes } from "../routes/index";

export default {
  components: {
    //"monitoramento-comp": monitoramento_comp,
    "monitoramento-pesquisa": monitoramento_pesquisa,
    "monitoramento-alteracoes": monitoramento_alteracoes,
    "monitoramento-pesquisadesc": monitoramento_pesquisaDesc
  },
  data() {
    return {
      usuario: "",
      routes: routes,
      pesquisa: 1,
      opcoes: [
        { text: "Por número NCM", value: 1 },
        { text: "Por descrição", value: 2 }
      ]
    };
  },

  methods: {
    atualizaValor(valor) {
      this.pesquisa = valor;
    }
  },

  async beforeCreate() {
    this.usuario = await serviceCookie.getCookie("idCliente");
    if (this.usuario.length > 0) //this.usuario = this.usuario.substring(3);

    await serviceHome.getContadorNCMs(this.usuario).then(
      res => {
        let contador = res;
      },
      err => {
        console.error(err);
      }
    );

    /* if (contador > 0) {
      this.routes.forEach(rota => {
        if (rota.name == "Pesquisa") rota.menu = true;
        if (rota.name == "Início") rota.menu = false;
        if (rota.name == "Monitoradas") rota.menu = true;
      });
      this.$router.push({ name: "Pesquisa" });
    } else {
      this.routes.forEach(rota => {
        if (rota.name == "Início") rota.menu = true;
        if (rota.name == "Pesquisa") rota.menu = false;
        if (rota.name == "Monitoradas") rota.menu = false;
      });
      this.$router.push({ name: "Início" });
    } */
  }
};
</script>

<style scoped>
.caixatoggle {
  width: 100px;
  height: 25px;
  border-radius: 25px;
  background-color: rgb(153, 153, 153);
  line-height: 25px;
}
.bola {
  height: 25px;
  width: 25px;
  background-color: rgb(214, 214, 214);
  border-radius: 50%;
}
.transicao {
  transition: all 2s;
}
.texto {
  transition: all 0.5s;
}

.titulo {
  
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.titulo h5 {
  font-family: Segoe, sans-serif;
  margin-bottom: 0;
  padding: 30px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.botaoradio {
  margin: 0 30px;
  margin-top: 10px;
}

.cardspadding {
  padding: 0px;
}
</style>